import z from "zod"

export const FOLLOW_UP_CONFIGURATION_DRAG_TYPE = "follow-up-configuration-row"

// Rows may only be reordered inside their own source product, so both the drag
// source and the drop target carry the group they belong to.
export const FollowUpConfigurationDragMetaSchema = z.object({
  entryID: z.string(),
  groupID: z.string()
})

export type FollowUpConfigurationDragMeta = z.infer<
  typeof FollowUpConfigurationDragMetaSchema
>
